export const validateEmail = email => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const makeid = length => {
  var result = '';
  var characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const validURL = str => {
  let newSTR = str.trim();
  var pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i',
  ); // fragment locator
  return !!pattern.test(newSTR);
};

export const getGolfPlayersView = original_players_list => {
  let players_data = {};
  original_players_list.map(pl => {
    if (
      players_data[pl.quarter_id] &&
      Object.keys(players_data[pl.quarter_id]).length > 0 &&
      players_data[pl.quarter_id][pl.group_number]
    ) {
      let arr = players_data[pl.quarter_id][pl.group_number];
      arr.push(pl.player);
      players_data[pl.quarter_id][pl.group_number] = arr;
    } else {
      let p_data = { ...players_data };
      p_data[pl.quarter_id] = {
        ...p_data[pl.quarter_id],
        [pl.group_number]: [{...pl.player, distance: pl.distance}],
      };
      players_data = { ...p_data };
    }
  });

  return players_data;
};
